var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Screen',[_c('AppBar',{attrs:{"title":"Page title","showBackButton":false}}),_vm._v(" "),_c('Breadcrumbs',{attrs:{"title":"Page title"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }